'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ButtonUploader = require('components/FineUploader/ButtonUploader');

var _ButtonUploader2 = _interopRequireDefault(_ButtonUploader);

var _responseCodes = require('helpers/responseCodes');

var _responseCodes2 = _interopRequireDefault(_responseCodes);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _log = require('utils/log');

var _log2 = _interopRequireDefault(_log);

var _RecipientsImportReport = require('containers/Project/RecipientsImportReport/RecipientsImportReport');

var _RecipientsImportReport2 = _interopRequireDefault(_RecipientsImportReport);

var _Modal = require('components/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _RecipientsImportsErrors = require('components/RecipientsImportsErrors/RecipientsImportsErrors');

var _RecipientsImportsErrors2 = _interopRequireDefault(_RecipientsImportsErrors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ImportRecipientsCSVButton.scss');

var TAG = 'ImportRecipientsCSVButton';

var ImportRecipientsCSVButton = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ImportRecipientsCSVButton, _PureComponent);

  function ImportRecipientsCSVButton() {
    var _ref;

    (0, _classCallCheck3.default)(this, ImportRecipientsCSVButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportRecipientsCSVButton.__proto__ || (0, _getPrototypeOf2.default)(ImportRecipientsCSVButton)).call.apply(_ref, [this].concat(args)));

    _this.state = { importData: null, importMessage: '', isShowModal: false };
    return _this;
  }

  (0, _createClass3.default)(ImportRecipientsCSVButton, [{
    key: 'onImportRecipientsError',
    value: function onImportRecipientsError(err) {
      _log2.default.w(TAG, 'Recipients CSV upload error', err);
      _toastr2.default.error('Uploading error');
    }
  }, {
    key: 'onImportRecipientsComplete',
    value: function onImportRecipientsComplete(id, name) {
      var resp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var code = resp.code,
          data = resp.data;
      var _context = this.context,
          t = _context.t,
          logout = _context.logout;


      if (code === _responseCodes2.default.sessionError) {
        return logout();
      }

      if (code) {
        this.setState({ importData: resp.data, importMessage: resp.msg, isShowModal: true });
      } else {
        _toastr2.default.success(t('Contacts imported'));
      }

      if (data) {
        this.props.onImport({ data: data });
      }
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.setState({ isShowModal: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          uploaderParams = _props.uploaderParams,
          buttonClass = _props.buttonClass,
          label = _props.label;
      var t = this.context.t;
      var _state = this.state,
          importData = _state.importData,
          importMessage = _state.importMessage,
          isShowModal = _state.isShowModal;

      var importRecipientsCallbacks = {
        error: this.onImportRecipientsError,
        complete: this.onImportRecipientsComplete
      };

      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)(styles.container, className) },
        _react2.default.createElement(_ButtonUploader2.default, {
          label: label || t('Import'),
          uploaderParams: uploaderParams,
          accept: '.csv',
          multiple: false,
          buttonClass: buttonClass,
          callbacks: importRecipientsCallbacks
        }),
        _react2.default.createElement(
          _Modal2.default,
          {
            className: styles.modal,
            show: isShowModal,
            onHide: this.hideModal,
            title: t('Contacts import report'),
            bsSize: 'lg',
            backdrop: true
          },
          _react2.default.createElement(_RecipientsImportsErrors2.default, {
            data: importData,
            message: importMessage,
            className: styles.errors
          }),
          _react2.default.createElement(_RecipientsImportReport2.default, {
            className: styles.report,
            data: importData
          })
        )
      );
    }
  }]);
  return ImportRecipientsCSVButton;
}(_react.PureComponent), _class2.propTypes = {
  buttonClass: _propTypes2.default.string,
  className: _propTypes2.default.string,
  label: _propTypes2.default.string,
  onImport: _propTypes2.default.func,
  uploaderParams: _propTypes2.default.object
}, _class2.contextTypes = {
  logout: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  buttonClass: 'btn-primary',
  onImport: _noop3.default,
  uploaderParams: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onImportRecipientsError', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onImportRecipientsError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onImportRecipientsComplete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onImportRecipientsComplete'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideModal', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hideModal'), _class.prototype)), _class);
exports.default = ImportRecipientsCSVButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ImportRecipientsCSVButton/ImportRecipientsCSVButton.js
// module id = 827
// module chunks = 1